import { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";

import { Menu } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import { Logo } from "./Logo/Logo";
import { IconButton, Drawer } from "@material-ui/core";
import icon from "./../../assets/svg/saltoLogo.svg";
import { AuthContext } from "../../auth/AuthHandler";
import { BarSup } from "./BarSup/BarSup";
import { useScrollDirection } from "../../hooks/use-scroll-direction";
import { SearchInput } from "./SearchInput/SearchInput";
import { ASaltoWecosystemCompany } from "./BarSup/ASaltoWecosystemCompany";

const Header = ({ email }) => {
  const authCtx = useContext(AuthContext);
  const history = useHistory();

  const direction = useScrollDirection();

  const [searchQuery, setSearchQuery] = useState("");

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  const { mobileView, drawerOpen } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1024
        ? setState((prevState) => ({
            ...prevState,
            mobileView: true,
          }))
        : setState((prevState) => ({
            ...prevState,
            mobileView: false,
          }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  // PENDING
  useEffect(() => {}, [searchQuery]);

  const handleSearch = async (searchValue) => {
    if (!searchValue.trim()) return;

    const searchParam = encodeURIComponent(searchValue);
    setSearchQuery("");
    history.push(`/search?q=${searchParam}`);
  };

  const displayDesktop = () => {
    return (
      <>
        <BarSup email={authCtx.email} logoutFunction={() => authCtx.logout()} />
        <header className={`header-desktop`}>
          <Logo>Release tracker</Logo>
          <SearchInput
            placeholder="Search"
            value={searchQuery}
            onChange={setSearchQuery}
            onSearch={handleSearch}
          />
        </header>
      </>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <div className="header-mobile close">
        <div className="hm-content">
          <div className="header-title-mobile">
            <Link to="/" onClick={handleDrawerClose}>
              <img className="icon" src={icon} alt="SALTO" />
            </Link>
            <h1 className="header-title-mobile-text">Release tracker</h1>
          </div>
          <IconButton
            {...{
              edge: "start",
              color: "inherit",
              "aria-label": "menu",
              "aria-haspopup": "true",
              onClick: state.drawerOpen ? handleDrawerClose : handleDrawerOpen,
            }}
          >
            {state.drawerOpen ? <CloseIcon /> : <Menu />}
          </IconButton>
        </div>
        <Drawer
          {...{
            anchor: "top",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <div className="drawerContainer">
            <div className="drawerContainer-item drawerContainer-logo">
              <a
                href="https://saltowecosystem.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group-company"
                tabIndex="-1"
                onClick={handleDrawerClose}
              >
                <ASaltoWecosystemCompany />
              </a>
            </div>
            <div className="drawerContainer-item drawerContainer-barSup">
              <BarSup
                email={authCtx.email}
                logoutFunction={() => authCtx.logout()}
                isMobile={true}
                onClick={handleDrawerClose}
              />
            </div>
            <div className="drawerContainer-item drawerContainer-search">
              <SearchInput
                placeholder="Search"
                value={searchQuery}
                onChange={setSearchQuery}
                onSearch={handleSearch}
                drawerClose={handleDrawerClose}
              />
            </div>
          </div>
        </Drawer>
      </div>
    );
  };

  return (
    <div
      className={`header-container header-${mobileView ? "open" : direction}`}
    >
      {mobileView ? displayMobile() : displayDesktop()}
    </div>
  );
};

export default Header;